module.exports = __webpack_public_path__ + "img/ezwrite6-platform-icon_web.033dd1c1.svg";